import { render, staticRenderFns } from "./NoteTabsContainer.vue?vue&type=template&id=0151ca23&"
import script from "./NoteTabsContainer.vue?vue&type=script&lang=js&"
export * from "./NoteTabsContainer.vue?vue&type=script&lang=js&"
import style0 from "./NoteTabsContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports